// Parallax.js
import React from 'react';

const Parallax = () => {
  return (
    <div className="parallax-section">
      {/* Vous pourriez ajouter du contenu ici si nécessaire, centré ou stylisé */}
      {/* Par exemple: <div className="parallax-content"><h2>Titre sur Parallaxe</h2></div> */}
      <style>{`
        .parallax-section {
          /* L'image de fond */
          background-image: url('/images/header5.png');

          /* Hauteur de la section parallax */
          min-height: 50vh; /* Vous pouvez ajuster cette valeur (ex: 400px, 60vh, etc.) */

          /* Création de l'effet parallax */
          background-attachment: fixed; /* C'est la clé de l'effet parallax simple */
          background-position: center;  /* Centre l'image */
          background-repeat: no-repeat; /* Empêche la répétition de l'image */
          background-size: cover;       /* S'assure que l'image couvre toute la zone */

          /* Utile si vous voulez superposer du contenu textuel par-dessus */
          position: relative; 
          display: flex; /* Si vous ajoutez du contenu à centrer */
          align-items: center; /* Si vous ajoutez du contenu à centrer */
          justify-content: center; /* Si vous ajoutez du contenu à centrer */
        }

        /* Optionnel: Si vous voulez ajouter du texte ou autre contenu par-dessus */
        /*
        .parallax-content {
          text-align: center;
          color: white;
          background-color: rgba(0, 0, 0, 0.3); // Léger fond pour la lisibilité
          padding: 20px;
          border-radius: 5px;
          z-index: 1;
        }
        .parallax-content h2 {
          font-size: 2.5rem;
          margin: 0;
        }
        */

        /* Sur mobile, background-attachment: fixed peut parfois causer des problèmes de performance
           ou ne pas rendre comme attendu. Une alternative est d'utiliser 'scroll' ou de le laisser
           tel quel et de tester sur les appareils cibles. Pour la plupart des navigateurs modernes,
           'fixed' fonctionne bien.
        */
        @media (max-width: 768px) {
          .parallax-section {
            /* Alternative pour mobile si 'fixed' pose problème : */
            /* background-attachment: scroll; */
            min-height: 40vh; /* Réduire un peu la hauteur sur mobile si besoin */
          }
        }
      `}</style>
    </div>
  );
};

export default Parallax;